@let userInfo = userInfo$ | async;
@let currentLanguage = currentLanguage$ | async;

<div class="mobile-menu">
  @if (userInfo?.isAdmin) {
    <button
      type="button"
      class="mobile-menu__admin-button"
      (click)="openAdminPanel()"
    >
      {{ 'header.buttons.admin-panel' | translate }}
    </button>
  }

  <div class="mobile-menu__section">
    @for (item of navMenuItems; track $index) {
      <ng-container
        *ngTemplateOutlet="menuRow; context: { $implicit: item }"
      />
    }

    <button type="button" class="mobile-menu__row" (click)="cycleLanguage()">
      <span class="mobile-menu__row-label">
        {{ 'header.menu.language' | translate }}
      </span>
      <span class="mobile-menu__row-value">
        {{ 'language.' + currentLanguage | translate }}
      </span>
    </button>
  </div>

  @if (userInfo) {
    <div class="mobile-menu__divider"></div>

    <div class="mobile-menu__section">
      @for (item of profileMenuItems; track $index) {
        <ng-container
          *ngTemplateOutlet="menuRow; context: { $implicit: item }"
        />
      }
    </div>

    <div class="mobile-menu__divider"></div>

    <button
      type="button"
      class="mobile-menu__row mobile-menu__row--secondary"
      (click)="logout()"
    >
      <lib-svg-icon class="mobile-menu__row-icon" icon="logout" />
      <span class="mobile-menu__row-label">
        {{ 'sidebar-menu.logout' | translate }}
      </span>
    </button>
  }
</div>

<ng-template #menuRow let-item>
  @if (item.url) {
    <a
      class="mobile-menu__row"
      [class.mobile-menu__row--secondary]="item.isSecondaryStyle"
      [class.mobile-menu__row--disabled]="item.isDisabled"
      routerLinkActive="mobile-menu__row--active"
      [routerLink]="item.url"
      [routerLinkActiveOptions]="{ exact: item.isExact ?? false }"
    >
      <ng-container
        *ngTemplateOutlet="rowBody; context: { $implicit: item }"
      />
    </a>
  } @else if (item.href) {
    <a
      class="mobile-menu__row"
      [class.mobile-menu__row--secondary]="item.isSecondaryStyle"
      [class.mobile-menu__row--disabled]="item.isDisabled"
      [href]="item.href"
      target="_blank"
      rel="noopener noreferrer"
    >
      <ng-container
        *ngTemplateOutlet="rowBody; context: { $implicit: item }"
      />
    </a>
  } @else if (item.dropdownMenu) {
    <button
      type="button"
      class="mobile-menu__row"
      [class.mobile-menu__row--secondary]="item.isSecondaryStyle"
      [disabled]="item.isDisabled"
      [libDropdownTrigger]="item.dropdownMenu"
      [isGlobal]="true"
    >
      <ng-container
        *ngTemplateOutlet="rowBody; context: { $implicit: item }"
      />
    </button>
  } @else if (item.callback) {
    <button
      type="button"
      class="mobile-menu__row"
      [class.mobile-menu__row--secondary]="item.isSecondaryStyle"
      [disabled]="item.isDisabled"
      (click)="item.callback()"
    >
      <ng-container
        *ngTemplateOutlet="rowBody; context: { $implicit: item }"
      />
    </button>
  }
</ng-template>

<ng-template #rowBody let-item>
  @if (item.icon) {
    <lib-svg-icon class="mobile-menu__row-icon" [icon]="item.icon" />
  }
  <span class="mobile-menu__row-label">
    @if (item.titleStream$) {
      {{ item.titleStream$ | async }}
    } @else if (item.title) {
      {{ item.title }}
    } @else {
      {{ (item.titleTranslateKey ?? '—') | translate }}
    }
  </span>
  @if (item.dropdownMenu) {
    <lib-svg-icon
      class="mobile-menu__row-trailing"
      size="16"
      icon="arrow-right"
    />
  }
</ng-template>
